import { DisplayDate, DisplayTime } from '@tock/time';
import { Typography } from 'omakase';
import { WaitlistRequestFields } from 'components/business/waitlist-dialog/WaitlistRequestForm';
import { calendarTicketTypesSelector } from 'selectors/calendarSelectors';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';

/**
 * Translates a set of valid waitlist request form fields in to a summary
 */
export const RequestSummary = () => {
  const { values } = useFormikContext<WaitlistRequestFields>();
  const ticketTypes = useSelector(calendarTicketTypesSelector);
  const experience = ticketTypes.find(({ id }) => id === Number(values.desiredExperience));

  return (
    <Typography variant="body02">
      You're interested in {experience?.name ?? 'any experience'}
      {` for `}
      {values.desiredPartySize} {values.desiredPartySize === '1' ? 'guest' : 'guests'}
      {` from `}
      <DisplayTime timeValue={values.desiredStartTime} />
      {` - `}
      <DisplayTime timeValue={values.desiredEndTime} />
      {` on `}
      {values.desiredDates.length > 1 ? (
        'multiple dates'
      ) : (
        <DisplayDate dateValue={values.desiredDates[0]} displayMonthAs="long" />
      )}
      .
    </Typography>
  );
};
